import { useCallback } from "react";
import { useMutation } from "@apollo/client";

/**
 * useCreateMutation
 * @param {*} gql
 * @returns
 */
const useCreateMutation = (gql) => {
  const [createMutation, {loading, error}] = useMutation(gql);

  /**
   * 登録処理
   */
  const create = useCallback(
    (params, onSuccess, onError) => {
      createMutation({
        variables: {
          data: { ...params },
        },
      })
        .then((res) => {
          const data = Object.values(res.data)[0];
          onSuccess(data);
        })
        .catch((e) => {
          console.log(e);
          onError(e);
        });
    },
    [createMutation]
  );

  return [create, loading, error];
};

export default useCreateMutation;
